/**
 * IdleFaceLayers.js
 *
 * Pure-data layer library used by IdleSmileController to give the
 * idle face quiet baseline life beneath the smile presets:
 *
 *   Layer 1  BASE_RESTING_TONE
 *     Constant offsets on brows / eyes / cheeks / nose so the
 *     face is never at perfect zero. NO mouth shapes — those collide
 *     with A2F lipsync.
 *
 *   Layer 2  MICRO_EXPRESSIONS
 *     Brief, asymmetric tics (think / suppressed / alert /
 *     concentration). The controller picks one every 6–12 s, eases
 *     it in (with its own fast time constant), holds 0.6–1.2 s,
 *     eases back to zero. Weights live in the 0.10–0.18 range so
 *     each tic is clearly perceptible against the surrounding
 *     smile preset. mouthSmile shapes are deliberately excluded so
 *     micros never fight the active smile preset; tongueOut is
 *     excluded because many character meshes lack it and it pokes
 *     through the lips on the meshes that do have it.
 *
 * Blink is intentionally NOT here — the existing BlinkController
 * owns blinking.
 */

export const BASE_RESTING_TONE = {
  browInnerUp: 0.15,
  browOuterUpLeft: 0.25,
  browOuterUpRight: 0.25,
  eyeSquintLeft: 0.15,
  eyeSquintRight: 0.15,
  cheekSquintLeft: 0.25,
  cheekSquintRight: 0.25,
  noseSneerLeft: 0.1,
  noseSneerRight: 0.1,
};

export const MICRO_EXPRESSIONS = [
  { browDownLeft: 0.8, browDownRight: 0.8 },
  { browDownLeft: 0.9 },
  { browDownRight: 0.9 },
  { mouthLeft: 0.5 },
  { mouthRight: 0.5 },
  { eyeWideLeft: 0.9, eyeWideRight: 0.9 },
  { eyeWideLeft: 0.7 },
  { eyeWideRight: 0.7 },
  { mouthStretchLeft: 0.5, mouthStretchRight: 0.5 },
  { jawLeft: 0.5 },
  { jawRight: 0.5 },
  { browOuterUpLeft: 0.9 },
  { browOuterUpRight: 0.9 },
  { noseSneerLeft: 0.9 },
  { noseSneerRight: 0.9 },
];
